<br><br>
<div class="container px-4  px-md-0">
    <div class="row trails align-items-center">
        <div class="col-12 col-md-7">
            <div class="header-content ">
                <h3 class="title my-2">
                    {{ "interview_attempts_title" | translate }}
                </h3>
                <p class="description">
                    {{ "vrTrails.tryFirstAttempt" | translate }}
                </p>
            </div>

            <!-- Loading State -->
            <!-- <div *ngIf="isLoading" class="text-center my-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div> -->

            <div class="attempts-list" *ngIf="!isLoading">
                <!-- First Attempt -->
                <div class="attempt-item mb-1">
                    <div class="d-flex gap-3 wrapperc">
                        <div class="d-flex gap-3 align-items-center">
                            <div class="attemp-number" [ngClass]="attemptIndex==0?'active':''">1</div>
                            <div class="attempt-text">
                                <h5 [ngClass]="attemptIndex==0?'active':''">{{ "vrTrails.firstAttempt" | translate }}</h5>
                                <p>{{ "vrTrails.withAiTraining" | translate }}</p>
                            </div>
                        </div>


                    </div>

                    <div class="col-5">
                        <!-- Show Start Now button -->
                        <button class="btn-start" [ngClass]="{
                  'gradient-button': !isPaid || (isPaid && interviewUploadStatus === 'COMPLETED'),
                  'disabled-button': isPaid && interviewUploadStatus === 'PENDING'
                }" [disabled]="isPaid && interviewUploadStatus !== 'COMPLETED'" *ngIf="attemptIndex == 0"
                            (click)="startAttempt(0)">
                            <span>{{ "vrTrails.startNow" | translate }} ></span>
                        </button>

                        <!-- View Result button for completed attempts -->
                        <button class="btn-start border-button" *ngIf="showViewResult(0)" (click)="viewResult(0)">
                            {{ "vrTrails.viewResult" | translate }}
                        </button>

                        <!-- Evaluation Pending/In Progress button - DISABLED -->
                        <button class="btn-start disabled-button" *ngIf="isEvaluationPending(0)" disabled
                            [title]="'vrTrails.evalTitle2h' | translate">
                            {{ "vrTrails.viewResult" | translate }}
                        </button>
                    </div>
                </div>
                <div class="col-12 info-text ">
                    <!-- Status Badge under the text -->
                    <div class="status-badge pending"
                        *ngIf="attemptIndex === 0 && isPaid && interviewUploadStatus === 'PENDING'">
                        <i class="bi bi-info-circle"></i>
                        <span><strong>{{ "vrTrails.preparing" | translate }}</strong> {{ "vrTrails.preparingHint" | translate }}</span>
                    </div>

                    <!-- Evaluation Pending Badge -->
                    <div class="status-badge evaluating" *ngIf="isEvaluationPending(0)">
                        <i class="bi bi-clock-history"></i>
                        <span><strong>{{ "vrTrails.evaluating" | translate }}</strong> {{ getEvaluationMessage(0) }}</span>
                    </div>
                </div>

                <!-- Second Attempt -->
                <div class="attempt-item my-md-5 my-3">
                    <div class="d-flex gap-3 wrapperc">
                        <div class="d-flex gap-3 align-items-center">
                            <div class="attemp-number" [ngClass]="attemptIndex==1?'active':''">2</div>
                            <div class="attempt-text">
                                <h5 [ngClass]="attemptIndex==1?'active':''">{{ "vrTrails.secondAttempt" | translate }}</h5>
                                <p>{{ "vrTrails.withAiTraining" | translate }}</p>
                            </div>
                        </div>

                        <!-- Evaluation Pending Badge -->
                        <div class="status-badge evaluating" *ngIf="isEvaluationPending(1)">
                            <i class="bi bi-clock-history"></i>
                            <span><strong>{{ "vrTrails.evaluating" | translate }}</strong> {{ getEvaluationMessage(1) }}</span>
                        </div>
                    </div>

                    <div class="col-5">
                        <!-- Show Start Now button for second attempt -->
                        <button class="btn-start" [ngClass]="{
                  'gradient-button': !isPaid || (isPaid && interviewUploadStatus === 'COMPLETED'),
                  ' gradient-button disabled-button': isPaid && interviewUploadStatus === 'PENDING'
                }" [disabled]="isPaid && interviewUploadStatus !== 'COMPLETED'" *ngIf="attemptIndex == 1"
                            (click)="startAttempt(1)">
                            <span>{{ "vrTrails.startNow" | translate }} ></span>
                        </button>

                        <!-- View Result button for second attempt -->
                        <button class="btn-start border-button" *ngIf="showViewResult(1)" (click)="viewResult(1)">
                            {{ "vrTrails.viewResult" | translate }}
                        </button>

                        <!-- Evaluation Pending/In Progress button - DISABLED -->
                        <button class="btn-start disabled-button" *ngIf="isEvaluationPending(1)" disabled
                            [title]="'vrTrails.evalTitle4h' | translate">
                            {{ "vrTrails.viewResult" | translate }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="info">
                💡 {{ "vrTrails.onlyTwoAttempts" | translate }}
            </div>
        </div>

        <div class="col-md-5 col-12">
            <img src="../../../../../assets/img/trails-head.png" class="w-100" alt="trails-head">
        </div>
    </div>

    <section class="mt-5">
        <div class="card">
            <div class="card-header py-3">
                {{ "vrTrails.guidelines" | translate }}
            </div>
            <div class="card-body d-flex p-2">
                <div class="card-left p-2 col-12 col-md-6">
                    <h6>{{ "vrTrails.steps" | translate }}</h6>
                    <ul>
                        <li>
                            <div class="icon">
                                <i class="bi bi-chat"></i>
                            </div>
                            <p>{{ "vrTrails.stepAsk" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-headphones"></i>
                            </div>
                            <p>{{ "vrTrails.stepListen" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-lightbulb"></i>
                            </div>
                            <p>{{ "vrTrails.stepThink" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-mic-fill"></i>
                            </div>
                            <p>{{ "vrTrails.stepRecord" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-check2-square"></i>
                            </div>
                            <p>{{ "vrTrails.stepReview" | translate }}</p>
                        </li>
                    </ul>
                </div>
                <div class="card-right p-2 col-12 col-md-6">
                    <h6>{{ "vrTrails.rules" | translate }}</h6>
                    <ul>
                        <li>
                            <div class="icon">
                                <i class="bi bi-camera-video"></i>
                            </div>
                            <p>{{ "vrTrails.ruleCamera" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-volume-off"></i>
                            </div>
                            <p>{{ "vrTrails.ruleSpeak" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-clock"></i>
                            </div>
                            <p>{{ "vrTrails.ruleAnswerTime" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-alarm"></i>
                            </div>
                            <p>{{ "vrTrails.ruleSessionTime" | translate }}</p>
                        </li>
                        <li>
                            <div class="icon">
                                <i class="bi bi-info-circle"></i>
                            </div>
                            <p>{{ "vrTrails.ruleChances" | translate }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>

    <!-- Payment Section - Only show if not paid -->
    <section class="cv-section" *ngIf="!isPaid">
        <div class="container">
            <div class="text-center mb-5">
                <h2 class="titlle">{{ 'pricing.interview_title_payment' | translate }}</h2>
                <p class="subtitle mt-5">
                    {{ 'pricing.interview_subtitle_payment' | translate }}
                    <br> {{ 'pricing.interview_subtitle1_payment' | translate }}
                </p>
            </div>
            <div class="row d-flex justify-content-center align-items-center">
                <div class="col-12 col-md-7 px-md-5">
                    <button class="gradientt-button" (click)="goToPayment('generate-training-interview')">
                        <span class="btn-text">{{ 'pricing.interview_button' | translate }}</span>
                        <span class="price-badge ms-3">200 EL</span>
                    </button>
                </div>
            </div>
        </div>
    </section>
</div>
